"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2693],{

/***/ 601523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ ArrowCouple; },
  "e": function() { return /* binding */ ArrowIcon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/ArrowIcons.tsx



var getBorderRadiusAccToShape = function(shape) {
    switch(shape){
        case "circular":
            return "18";
        case "square":
            return "0";
        case "rounded":
            return "5";
    }
};
function ArrowRightV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "36",
                fill: props.bgColor || "#fff",
                opacity: typeof props.bgOpacity === "number" ? props.bgOpacity : 0.4,
                rx: getBorderRadiusAccToShape(props.iconShape),
                transform: "matrix(-1 0 0 1 36 0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_112_2612)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: props.arrowColor || "#fff",
                    strokeWidth: "1.5",
                    d: "M15.578 11.828l5.819 5.818-5.819 5.819"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_112_2612",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20.571",
                        height: "20.571",
                        fill: "#fff",
                        rx: "10.286",
                        transform: "matrix(0 1 1 0 7.7 7.713)"
                    })
                })
            })
        ]
    }));
}
function ArrowLeftV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "36",
                fill: props.bgColor || "#fff",
                opacity: typeof props.bgOpacity === "number" ? props.bgOpacity : 0.4,
                rx: getBorderRadiusAccToShape(props.iconShape)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_112_2596)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: props.arrowColor || "#fff",
                    strokeWidth: "1.5",
                    d: "M20.422 11.828l-5.819 5.818 5.819 5.819"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_112_2596",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20.571",
                        height: "20.571",
                        x: "28.301",
                        y: "7.713",
                        fill: "#fff",
                        rx: "10.286",
                        transform: "rotate(90 28.3 7.713)"
                    })
                })
            })
        ]
    }));
}
function ArrowRightV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#fff",
                opacity: "0.2",
                rx: getBorderRadiusAccToShape(props.iconShape),
                transform: "matrix(-1 0 0 1 36 0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#D9D9D9",
                d: "M19.417 16.333L24 11.667l-4.583 4.666zM24 11.667L19.417 7 24 11.667zm0 0H13h11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M19.417 16.333L24 11.667m0 0L19.417 7M24 11.667H13"
            })
        ]
    }));
}
function ArrowLeftV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#fff",
                opacity: "0.2",
                rx: getBorderRadiusAccToShape(props.iconShape)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#D9D9D9",
                d: "M16.583 16.333L12 11.667l4.583 4.666zM12 11.667L16.583 7 12 11.667zm0 0h11-11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M16.583 16.333L12 11.667m0 0L16.583 7M12 11.667h11"
            })
        ]
    }));
}
function ArrowLeftV3(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_d_255_271)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        filter: "url(#filter1_d_255_271)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "7",
                            y: "5",
                            width: "36",
                            height: "36",
                            rx: getBorderRadiusAccToShape(props.iconShape),
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "clip-path": "url(#clip0_255_271)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M27.4159 16.83L21.5974 22.6484L27.4159 28.4669",
                            stroke: "#111C36",
                            "stroke-width": "2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_255_271",
                        x: "0",
                        y: "0",
                        width: "50",
                        height: "50",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "3.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_271"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_271",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_d_255_271",
                        x: "5.5",
                        y: "3.5",
                        width: "39",
                        height: "39",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "0.75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0666667 0 0 0 0 0.109804 0 0 0 0 0.211765 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_271"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_271",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_255_271",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "35.2891",
                            y: "12.7168",
                            width: "20.5714",
                            height: "20.5714",
                            rx: "10.2857",
                            transform: "rotate(90 35.2891 12.7168)",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx





var ArrowIcon = function(props) {
    var _onClick = props.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _imageProps = props.imageProps, imageProps = _imageProps === void 0 ? {} : _imageProps, arrowDirection = props.arrowDirection, arrowType = props.arrowType;
    var Element = null;
    var _imageProps1 = (0,_object_spread/* default */.Z)({
        height: 36,
        width: 36,
        style: {},
        className: "",
        bgColor: "",
        bgOpacity: "",
        arrowColor: "",
        isShadowTypeIcon: false
    }, imageProps);
    var addShadow = _imageProps1.isShadowTypeIcon;
    switch(arrowType){
        case "v1":
            Element = arrowDirection === "left" ? ArrowLeftV1 : ArrowRightV1;
            break;
        case "v2":
            Element = arrowDirection === "left" ? ArrowLeftV2 : ArrowRightV2;
            break;
        case "v3":
            Element = ArrowLeftV3;
            break;
        default:
            Element = null;
    }
    if (!Element) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,bundle_mjs/* twMerge */.m6)("tw-pointer-events-auto tw-cursor-pointer", _imageProps1.className, addShadow ? " tw-inline-block " : ""),
        style: {
            height: imageProps.height,
            width: imageProps.width,
            filter: addShadow ? "drop-shadow(0 4px 10px #00000029)" : ""
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({}, _imageProps1))
    });
};
var ArrowCouple = function(param) {
    var _handleNextClick = param.handleNextClick, handleNextClick = _handleNextClick === void 0 ? function() {} : _handleNextClick, _handlePrevClick = param.handlePrevClick, handlePrevClick = _handlePrevClick === void 0 ? function() {} : _handlePrevClick, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, _arrowType = param.arrowType, arrowType = _arrowType === void 0 ? "v1" : _arrowType, _className = param.className, className = _className === void 0 ? "" : _className, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass, _imageProps = param.imageProps, imageProps = _imageProps === void 0 ? {} : _imageProps, _style = param.style, style = _style === void 0 ? {} : _style;
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: style,
        className: classnames_default()("tw-absolute tw-top-[50%] tw-flex tw-w-[100%] tw-translate-y-[-50%] tw-items-center tw-justify-between tw-px-[40px]", className, containerClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                onClick: handlePrevClick,
                arrowDirection: "left",
                arrowType: arrowType,
                imageProps: imageProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                onClick: handleNextClick,
                arrowDirection: "right",
                arrowType: arrowType,
                imageProps: imageProps
            })
        ]
    });
};


/***/ }),

/***/ 172693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_GalleryWidget; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(101657);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Constants/index.tsx
var Constants = __webpack_require__(26763);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(496664);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx + 1 modules
var Arrows = __webpack_require__(601523);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(826910);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var utils = __webpack_require__(290331);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(489429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/constant.ts
var ORIGINAL_IMAGE_WIDTH = "original";
var SCROLL_CONSTANT = {
    SMOOTH: "smooth",
    NEAREST: "nearest",
    CENTER: "center"
};
var ARROW_ACTION_TYPE = {
    PREVIOUS: "prev",
    NEXT: "next"
};
var IMAGE_INDEX_TYPE = {
    CURRENT: "current",
    FIRST: "first",
    LAST: "last"
};
var STATIC_IMAGE_PATH = "/assets/images/richTextWithImage.png";

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/helper.ts
var getVisibleImages = function(data) {
    return data === null || data === void 0 ? void 0 : data.filter(function(images) {
        return images === null || images === void 0 ? void 0 : images.isVisible;
    });
};

// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/ThumbnailLayout.tsx













var ARROW_STYLE = {
    arrowType: "v3",
    arrowStyle: {
        bgColor: "#FFFFFF",
        bgOpacity: 1,
        arrowColor: "#000000"
    }
};
var ThumbnailLayout = function(props) {
    var handleImageClick = function handleImageClick() {
        if (isMobile) {
            setFromModal(true);
            setShowThumbnailModalMobile(true);
        }
    };
    var renderImage = function renderImage(imageData) {
        var isActiveImage = imageData.currentIndex === activeIndex;
        var activeImageStyle = {
            maxWidth: !isMobile ? "1200px" : "100%",
            height: !isMobile ? window.innerHeight * 0.7 > 600 ? "600px" : window.innerHeight * 0.7 : "250px",
            width: "100%"
        };
        var nonActiveImage = {
            width: !isMobile ? "180px" : "20px",
            height: !isMobile ? "284px" : "160px",
            opacity: ".7"
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: handleImageClick,
            style: isActiveImage ? activeImageStyle : nonActiveImage,
            className: " tw-overflow-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                decoding: "async",
                className: classnames_default()("tw-h-full tw-w-full tw-bg-black tw-object-cover", "".concat(!isMobile ? (ContentAnimationStyles_module_default())[(0,utils/* getCurrentClass */.WR)(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.hoverEffect)] : "")),
                style: isActiveImage ? activeImageStyle : nonActiveImage,
                src: imageData.url || STATIC_IMAGE_PATH
            })
        });
    };
    var handleImageNextAndPrev = function handleImageNextAndPrev(type) {
        var updatedActiveIndex = activeIndex;
        if (type === ARROW_ACTION_TYPE.PREVIOUS) {
            updatedActiveIndex = activeIndex === 0 ? (imagesList === null || imagesList === void 0 ? void 0 : imagesList.length) - 1 : updatedActiveIndex - 1;
        } else {
            updatedActiveIndex = activeIndex === (imagesList === null || imagesList === void 0 ? void 0 : imagesList.length) - 1 ? 0 : updatedActiveIndex + 1;
        }
        setActiveIndex(updatedActiveIndex);
    };
    var handleThumbnailClick = function handleThumbnailClick(index) {
        setActiveIndex(index);
    };
    var handleCloseClick = function handleCloseClick() {
        setShowThumbnailModalMobile(false);
        onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
    };
    var getImageData = function getImageData(type, index) {
        switch(type){
            case IMAGE_INDEX_TYPE.CURRENT:
                var ref;
                return {
                    currentIndex: index,
                    url: (ref = imagesList[index]) === null || ref === void 0 ? void 0 : ref.imageUrl
                };
            case IMAGE_INDEX_TYPE.FIRST:
                var ref1;
                return {
                    currentIndex: (imagesList === null || imagesList === void 0 ? void 0 : imagesList.length) - 1,
                    url: (ref1 = imagesList[(imagesList === null || imagesList === void 0 ? void 0 : imagesList.length) - 1]) === null || ref1 === void 0 ? void 0 : ref1.imageUrl
                };
            case IMAGE_INDEX_TYPE.LAST:
                var ref2;
                return {
                    currentIndex: 0,
                    url: (ref2 = imagesList[0]) === null || ref2 === void 0 ? void 0 : ref2.imageUrl
                };
        }
    };
    var renderLayoutImages = // Render images
    function renderLayoutImages() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-w-[100%] tw-items-center tw-justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: !isMobile && showThumbnailImages ? (containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) || "" : ""
                },
                className: "tw-flex tw-max-w-[1240px] tw-items-center tw-justify-center",
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* ArrowIcon */.e, {
                        onClick: function() {
                            return handleImageNextAndPrev(ARROW_ACTION_TYPE.PREVIOUS);
                        },
                        arrowDirection: "left",
                        arrowType: ARROW_STYLE.arrowType,
                        imageProps: ARROW_STYLE.arrowStyle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: !isMobile ? window.innerHeight * 0.7 : ""
                        },
                        onTouchStart: handleTouchStart,
                        onTouchEnd: handleTouchEnd,
                        ref: imageRef,
                        className: "tw-w-[100%] ".concat(!isMobile ? "tw-max-h-[600px] tw-gap-[20px]" : "tw-h-[250px] tw-max-w-[100%] tw-gap-[12px]", " tw-flex tw-items-center tw-justify-center"),
                        children: imagesList === null || imagesList === void 0 ? void 0 : imagesList.map(function(data, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-transition-opacity tw-duration-500 ".concat(activeIndex === index ? "tw-visible tw-opacity-100" : "tw-invisible tw-absolute tw-opacity-0", "\n                  "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-items-center tw-justify-center ".concat(!isMobile ? "tw-gap-[20px]" : "tw-gap-[12px]", " "),
                                    children: renderImage(getImageData("current", index))
                                })
                            }, data.imageUrl + index);
                        })
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* ArrowIcon */.e, {
                        onClick: function() {
                            return handleImageNextAndPrev(ARROW_ACTION_TYPE.NEXT);
                        },
                        arrowDirection: "right",
                        arrowType: ARROW_STYLE.arrowType,
                        imageProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ARROW_STYLE.arrowStyle), {
                            className: "tw-rotate-180"
                        })
                    })
                ]
            })
        });
    };
    var renderThumbnail = // Render thumbnails
    function renderThumbnail() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-items-center tw-justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-[24px] tw-flex tw-items-center tw-justify-center ".concat(isMobile ? "tw-w-[100%]" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: thumnailRef,
                    className: "no-scrollbar pr-[2px] tw-relative tw-mx-auto tw-flex tw-items-center tw-gap-[12px] tw-overflow-x-auto tw-overflow-y-hidden tw-whitespace-nowrap tw-pl-[16px]",
                    style: {
                        maxWidth: !isMobile ? isBuilder ? "800px" : "1200px" : "100%",
                        scrollbarWidth: "none"
                    },
                    children: imagesList === null || imagesList === void 0 ? void 0 : imagesList.map(function(data, index) {
                        var isActiveIndex = index === activeIndex;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(isActiveIndex ? !isMobile ? "tw-h-[68px] tw-w-[68px]" : "tw-h-[56px] tw-w-[56px]" : !isMobile ? "tw-h-[56px] tw-w-[56px]" : "tw-h-[48px] tw-w-[48px] tw-opacity-80", " tw-flex tw-shrink-0 tw-cursor-pointer \n              tw-items-center tw-justify-center "),
                            onClick: function() {
                                return handleThumbnailClick(index);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                decoding: "async",
                                src: (data === null || data === void 0 ? void 0 : data.imageUrl) || STATIC_IMAGE_PATH,
                                className: "tw-h-full tw-w-full tw-object-cover ".concat(globalBorderRadius > 8 ? "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer" : ""),
                                style: {
                                    border: isActiveIndex ? "1px solid ##111C3633" : "",
                                    boxShadow: isActiveIndex ? "0px 0px 4px 0px #111C365C" : "",
                                    borderRadius: globalBorderRadius > 8 ? "8px" : globalBorderRadius
                                }
                            })
                        }, index);
                    })
                })
            })
        });
    };
    var renderMobileModalImage = function renderMobileModalImage() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onTouchStart: handleTouchStart,
            onTouchEnd: handleTouchEnd,
            className: "max-h-[400px] tw-w-[100%]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: ((ref = imagesList[activeIndex]) === null || ref === void 0 ? void 0 : ref.imageUrl) || STATIC_IMAGE_PATH,
                width: "100%"
            })
        });
    };
    var renderThumnailModal = function renderThumnailModal() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            open: showThumbnailModalMobile,
            style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                background: "transparent"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative tw-flex tw-h-[100%] tw-w-[100%] tw-flex-col tw-justify-center tw-bg-transparent",
                children: [
                    renderMobileModalImage(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-absolute tw-bottom-20 tw-left-0 tw-w-[100%] tw-overflow-x-auto tw-whitespace-nowrap",
                        children: renderThumbnail()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleCloseClick,
                        className: "ic-cross-bg-black-lg wb-sprite tw-absolute tw-right-[20px] tw-top-[20px]"
                    })
                ]
            })
        });
    };
    var renderImageContent = function renderImageContent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                renderLayoutImages(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(isMobile ? "tw-absolute tw-bottom-0 tw-left-0 tw-w-[100%] tw-overflow-x-auto tw-whitespace-nowrap" : ""),
                    children: renderThumbnail()
                })
            ]
        });
    };
    var ref, ref1, ref2;
    var cardFrame = props.cardFrame, _currentIndex = props.currentIndex, currentIndex = _currentIndex === void 0 ? 0 : _currentIndex, _isThumbnailModal = props.isThumbnailModal, isThumbnailModal = _isThumbnailModal === void 0 ? false : _isThumbnailModal, onCloseClick = props.onCloseClick;
    var ref3 = (0,react.useState)(0), activeIndex = ref3[0], setActiveIndex = ref3[1];
    var ref4 = (0,react.useState)(isThumbnailModal), fromModal = ref4[0], setFromModal = ref4[1];
    var ref5 = (0,react.useState)(true), showThumbnailModalMobile = ref5[0], setShowThumbnailModalMobile = ref5[1];
    var imageRef = (0,react.useRef)(null);
    var thumnailRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var ref6 = (0,react.useState)(false), showThumbnailImages = ref6[0], setShowThumbnailImages = ref6[1];
    var imagesList = getVisibleImages(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.imagesData);
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref7 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref7.widgetContextState, globalStyle = _widgetContextState.globalStyle, isBuilder = _widgetContextState.isBuilder;
    var globalBorderRadius = globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.imageCards) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.borderRadius) === null || ref2 === void 0 ? void 0 : ref2.replace("px !important", "");
    var touchStartX = 0;
    var touchEndX = 0;
    (0,react.useEffect)(function() {
        setActiveIndex(currentIndex);
        setShowThumbnailImages(true);
    }, [
        currentIndex
    ]);
    (0,react.useEffect)(function() {
        setFromModal(isThumbnailModal);
    }, [
        isThumbnailModal
    ]);
    var handleTouchStart = function(e) {
        var ref;
        touchStartX = (ref = e === null || e === void 0 ? void 0 : e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX;
    };
    var handleTouchEnd = function(e) {
        var ref;
        touchEndX = (ref = e === null || e === void 0 ? void 0 : e.changedTouches[0]) === null || ref === void 0 ? void 0 : ref.clientX;
        handleSwipe();
    };
    var handleSwipe = function() {
        if (touchStartX - touchEndX > 50) {
            setActiveIndex(function(prev) {
                return (prev + 1) % imagesList.length;
            });
        } else if (touchEndX - touchStartX > 50) {
            setActiveIndex(function(prev) {
                return (prev - 1 + imagesList.length) % imagesList.length;
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: containerRef,
            className: "tw-relative tw-w-[100%] ".concat(isMobile ? "tw-h-[350px]" : "", " ").concat(fromModal && !isMobile ? "tw-w-[90vw]" : ""),
            children: showThumbnailImages && (showThumbnailModalMobile && fromModal && isMobile ? renderThumnailModal() : renderImageContent())
        })
    });
};
/* harmony default export */ var GalleryWidget_ThumbnailLayout = (ThumbnailLayout);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/RenderThumnailModal.tsx






function RenderThumnailModal(props) {
    var handleClose = function handleClose() {
        setConfig(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                isVisible: false
            });
        });
    };
    var cardFrame = props.cardFrame, config = props.config, setConfig = props.setConfig;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: config.isVisible,
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "transparent"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-max-w-[1500px] tw-bg-transparent tw-flex tw-justify-center tw-relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_ThumbnailLayout, {
                    cardFrame: cardFrame,
                    currentIndex: config.currIndex,
                    isThumbnailModal: true,
                    onCloseClick: handleClose
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: handleClose,
                    className: "ic-cross-bg-black-lg wb-sprite tw-fixed tw-top-[20px] tw-right-[20px]"
                })
            ]
        })
    });
}
/* harmony default export */ var GalleryWidget_RenderThumnailModal = (RenderThumnailModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useLoadVisibleReel.ts
var useLoadVisibleReel = __webpack_require__(50722);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/videoUtility.js
var videoUtility = __webpack_require__(964582);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/CarouselGridItem.tsx











function CarouselGridItem(props) {
    var videoRef = props.videoRef, data = props.data, index = props.index, listPresentation = props.listPresentation, cardFrame = props.cardFrame, oneGridCellGeometry = props.oneGridCellGeometry, handleImageClick = props.handleImageClick;
    var layoutName = listPresentation.layoutName, imageWidth = listPresentation.imageWidth;
    var ref = (0,react.useState)(false), loadVideo = ref[0], setLoadVideo = ref[1];
    (0,useLoadVisibleReel/* useLoadVisibleReel */.c)({
        videoRef: videoRef,
        reelIndex: index,
        setLoadVideo: setLoadVideo,
        loadVideo: loadVideo
    });
    var shapeStyleCalculated = (0,utils/* getShapeStyles */.cw)(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.imageShape, oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width);
    var shapeStyle = shapeStyleCalculated[0];
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var imageURL = data === null || data === void 0 ? void 0 : data.imageUrl;
    var getStyleAccToLayout = function() {
        if (layoutName === Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE || layoutName === Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO && imageWidth !== ORIGINAL_IMAGE_WIDTH) {
            return {
                width: oneGridCellGeometry.width,
                height: oneGridCellGeometry.height,
                minHeight: 100
            };
        }
        return {
            maxWidth: oneGridCellGeometry.width * 1.8,
            height: oneGridCellGeometry.height,
            minHeight: 100
        };
    };
    var styleAccToLayout = getStyleAccToLayout();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: function() {
            return handleImageClick(index);
        },
        className: "tw-cursor-pointer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: (0,_object_spread/* default */.Z)({}, styleAccToLayout, shapeStyle.style),
            className: classnames_default()("tw-overflow-hidden", shapeStyle.className),
            children: (0,videoUtility/* isVideoUrl */.cb)(imageURL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: function(node) {
                    return videoRef[index] = node;
                },
                className: "tw-z-10 tw-h-full tw-w-full tw-object-cover",
                loop: true,
                autoPlay: true,
                playsInline: true,
                muted: true,
                src: loadVideo ? imageURL : undefined
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: imageURL || STATIC_IMAGE_PATH,
                style: styleAccToLayout,
                loading: "lazy",
                decoding: "async",
                className: classnames_default()(!isMobile ? (ContentAnimationStyles_module_default())[(0,utils/* getCurrentClass */.WR)(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.hoverEffect)] : "", "tw-object-cover")
            })
        })
    }, index);
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/CarouselGridLayout.tsx







function CarouselGridLayout(props) {
    var handleImageClick = function handleImageClick(index) {
        setShowThumbnailLayout(function(prev) {
            return {
                currIndex: index,
                isVisible: !prev.isVisible
            };
        });
    };
    var cardFrame = props.cardFrame, containerTracks = props.containerTracks, viewAllItemsConfig = props.viewAllItemsConfig;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        isVisible: false,
        currIndex: 0
    }), showThumbnailLayout = ref[0], setShowThumbnailLayout = ref[1];
    var imagesData = getVisibleImages(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.imagesData);
    var numItemsToShow = containerTracks.numColumns * containerTracks.numRows;
    var imagesList = imagesData === null || imagesData === void 0 ? void 0 : imagesData.slice(0, (viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible) ? imagesData === null || imagesData === void 0 ? void 0 : imagesData.length : numItemsToShow);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            imagesList === null || imagesList === void 0 ? void 0 : imagesList.map(function(data, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselGridItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    handleImageClick: handleImageClick
                }, props), {
                    data: data,
                    index: index,
                    videoRef: videoRef
                }), data === null || data === void 0 ? void 0 : data.imageUrl);
            }),
            showThumbnailLayout.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_RenderThumnailModal, {
                cardFrame: cardFrame,
                config: showThumbnailLayout,
                setConfig: setShowThumbnailLayout
            })
        ]
    });
}
/* harmony default export */ var GalleryWidget_CarouselGridLayout = (CarouselGridLayout);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(263366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(487462);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(615463);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(490512);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(690948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js + 1 modules
var DefaultPropsProvider = __webpack_require__(167023);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(545154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(922104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ImageList/imageListClasses.js


function getImageListUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiImageList', slot);
}
const imageListClasses = (0,generateUtilityClasses/* default */.Z)('MuiImageList', ['root', 'masonry', 'quilted', 'standard', 'woven']);
/* harmony default export */ var ImageList_imageListClasses = ((/* unused pure expression or super */ null && (imageListClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/ImageList/ImageListContext.js
'use client';



/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */
const ImageListContext = /*#__PURE__*/react.createContext({});
if (false) {}
/* harmony default export */ var ImageList_ImageListContext = (ImageListContext);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ImageList/ImageList.js
'use client';



const _excluded = ["children", "className", "cols", "component", "rowHeight", "gap", "style", "variant"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant]
  };
  return (0,composeClasses/* default */.Z)(slots, getImageListUtilityClass, classes);
};
const ImageListRoot = (0,styled/* default */.ZP)('ul', {
  name: 'MuiImageList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant]];
  }
})(({
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({
    display: 'grid',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
  }, ownerState.variant === 'masonry' && {
    display: 'block'
  });
});
const ImageList = /*#__PURE__*/react.forwardRef(function ImageList(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiImageList'
  });
  const {
      children,
      className,
      cols = 2,
      component = 'ul',
      rowHeight = 'auto',
      gap = 4,
      style: styleProp,
      variant = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const contextValue = react.useMemo(() => ({
    rowHeight,
    gap,
    variant
  }), [rowHeight, gap, variant]);
  react.useEffect(() => {
    if (false) {}
  }, []);
  const style = variant === 'masonry' ? (0,esm_extends/* default */.Z)({
    columnCount: cols,
    columnGap: gap
  }, styleProp) : (0,esm_extends/* default */.Z)({
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap
  }, styleProp);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    gap,
    rowHeight,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageListRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx/* default */.Z)(classes.root, classes[variant], className),
    ref: ref,
    style: style,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageList_ImageListContext.Provider, {
      value: contextValue,
      children: children
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ImageList_ImageList = (ImageList);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/react-is/index.js
var react_is = __webpack_require__(776607);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(619208);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ImageListItem/imageListItemClasses.js


function getImageListItemUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiImageListItem', slot);
}
const imageListItemClasses = (0,generateUtilityClasses/* default */.Z)('MuiImageListItem', ['root', 'img', 'standard', 'woven', 'masonry', 'quilted']);
/* harmony default export */ var ImageListItem_imageListItemClasses = (imageListItemClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ImageListItem/ImageListItem.js
'use client';



const ImageListItem_excluded = ["children", "className", "cols", "component", "rows", "style"];












const ImageListItem_useUtilityClasses = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant],
    img: ['img']
  };
  return (0,composeClasses/* default */.Z)(slots, getImageListItemUtilityClass, classes);
};
const ImageListItemRoot = (0,styled/* default */.ZP)('li', {
  name: 'MuiImageListItem',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${ImageListItem_imageListItemClasses.img}`]: styles.img
    }, styles.root, styles[ownerState.variant]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  position: 'relative'
}, ownerState.variant === 'standard' && {
  // For titlebar under list item
  display: 'flex',
  flexDirection: 'column'
}, ownerState.variant === 'woven' && {
  height: '100%',
  alignSelf: 'center',
  '&:nth-of-type(even)': {
    height: '70%'
  }
}, {
  [`& .${ImageListItem_imageListItemClasses.img}`]: (0,esm_extends/* default */.Z)({
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    display: 'block'
  }, ownerState.variant === 'standard' && {
    height: 'auto',
    flexGrow: 1
  })
}));
const ImageListItem = /*#__PURE__*/react.forwardRef(function ImageListItem(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiImageListItem'
  });

  // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
  const {
      children,
      className,
      cols = 1,
      component = 'li',
      rows = 1,
      style
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ImageListItem_excluded);
  const {
    rowHeight = 'auto',
    gap,
    variant
  } = react.useContext(ImageList_ImageListContext);
  let height = 'auto';
  if (variant === 'woven') {
    height = undefined;
  } else if (rowHeight !== 'auto') {
    height = rowHeight * rows + gap * (rows - 1);
  }
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    cols,
    component,
    gap,
    rowHeight,
    rows,
    variant
  });
  const classes = ImageListItem_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageListItemRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx/* default */.Z)(classes.root, classes[variant], className),
    ref: ref,
    style: (0,esm_extends/* default */.Z)({
      height,
      gridColumnEnd: variant !== 'masonry' ? `span ${cols}` : undefined,
      gridRowEnd: variant !== 'masonry' ? `span ${rows}` : undefined,
      marginBottom: variant === 'masonry' ? gap : undefined,
      breakInside: variant === 'masonry' ? 'avoid' : undefined
    }, style),
    ownerState: ownerState
  }, other, {
    children: react.Children.map(children, child => {
      if (! /*#__PURE__*/react.isValidElement(child)) {
        return null;
      }
      if (false) {}
      if (child.type === 'img' || (0,isMuiElement/* default */.Z)(child, ['Image'])) {
        return /*#__PURE__*/react.cloneElement(child, {
          className: (0,clsx/* default */.Z)(classes.img, child.props.className)
        });
      }
      return child;
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ImageListItem_ImageListItem = (ImageListItem);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/GalleryCollage1.tsx











function GalleryCollage1(props) {
    var getColsDetails = function getColsDetails(index) {
        if (index === 0 || index === 1) {
            return 2;
        }
        return 1;
    };
    var getRowsDetails = function getRowsDetails(index) {
        if (index === 0) {
            return 2;
        }
        return 1;
    };
    var getHeight = function getHeight(index, rows) {
        if (isMobile) {
            if (index === 0) {
                return heightAccToDevice * 1.75 + (gridGapAxis === null || gridGapAxis === void 0 ? void 0 : gridGapAxis.columnGap);
            } else if (index == 2 || index == 3) return heightAccToDevice * 0.75;
            else return heightAccToDevice;
        } else if (index === 0) return rows * heightAccToDevice + (gridGapAxis === null || gridGapAxis === void 0 ? void 0 : gridGapAxis.columnGap);
        return rows * heightAccToDevice;
    };
    var getSrcSet = function getSrcSet(url, rows, columns, index) {
        var width = oneGridCellGeometry.width;
        var updatedUrl = url ? url : "/assets/images/richTextWithImage.png";
        var imageUrl = "".concat(updatedUrl, "?w=").concat(width * columns, "&h=").concat(getHeight(index, rows), "&fit=crop&auto=format");
        return {
            srcset: imageUrl,
            src: imageUrl
        };
    };
    var handleImageClick = function handleImageClick() {
        setShowThumbnailLayout(function(prev) {
            return {
                currIndex: 3,
                isVisible: !prev.isVisible
            };
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)({
        isVisible: false,
        currIndex: 3
    }), showThumbnailLayout = ref3[0], setShowThumbnailLayout = ref3[1];
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref4.widgetContextState.globalStyle;
    var globalBorderRadius = globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.imageCards) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.borderRadius) === null || ref2 === void 0 ? void 0 : ref2.replace("!important", "");
    var cardFrame = props.cardFrame, oneGridCellGeometry = props.oneGridCellGeometry, _gridGapAxis = props.gridGapAxis, gridGapAxis = _gridGapAxis === void 0 ? {} : _gridGapAxis;
    var imagesList = getVisibleImages(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.imagesData);
    var hiddenImageLength = (imagesList === null || imagesList === void 0 ? void 0 : imagesList.length) - 4;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var heightAccToDevice = isMobile ? 150 : 300;
    var updatedImageData = (0,react.useMemo)(function() {
        var ref;
        var imageModifiedData = (ref = imagesList === null || imagesList === void 0 ? void 0 : imagesList.slice(0, 4)) === null || ref === void 0 ? void 0 : ref.map(function(data, index) {
            return {
                img: data.imageUrl,
                cols: getColsDetails(index),
                rows: getRowsDetails(index)
            };
        });
        return imageModifiedData;
    }, [
        imagesList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative tw-h-full tw-w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageList_ImageList, {
                sx: {
                    width: "100%",
                    height: "100%"
                },
                variant: "quilted",
                cols: 4,
                gap: gridGapAxis.columnGap,
                children: updatedImageData.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageListItem_ImageListItem, {
                        cols: item.cols || 1,
                        rows: item.rows || 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                height: getHeight(index, item.rows),
                                width: "100%"
                            },
                            className: "tw-relative tw-h-[100%] tw-w-[100%] tw-overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getSrcSet(item.img, item.rows, item.cols, index)), {
                                    alt: item.title,
                                    loading: "lazy",
                                    decoding: "async",
                                    className: "tw-cursor-pointer tw-object-cover ".concat(!isMobile ? (ContentAnimationStyles_module_default())[(0,utils/* getCurrentClass */.WR)(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.hoverEffect)] : ""),
                                    height: getHeight(index, item.rows),
                                    width: "100%"
                                })),
                                index === 3 && hiddenImageLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        borderRadius: globalBorderRadius
                                    },
                                    onClick: handleImageClick,
                                    className: "tw-absolute tw-bottom-0 tw-right-0 tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-flex-col tw-justify-center tw-bg-[#00000066] ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(isMobile ? "tw-text-[20px]" : "tw-text-[32px]", " tw-flex tw-justify-center tw-gap-[4px] tw-font-normal tw-text-white"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: hiddenImageLength
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, item.img);
                })
            }),
            showThumbnailLayout.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_RenderThumnailModal, {
                cardFrame: cardFrame,
                config: showThumbnailLayout,
                setConfig: setShowThumbnailLayout
            })
        ]
    });
}
/* harmony default export */ var GalleryWidget_GalleryCollage1 = (GalleryCollage1);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/GalleryCollage2.tsx











function GalleryCollage2(props) {
    var getSrcSet = function getSrcSet(url, rows, columns, index) {
        var width = oneGridCellGeometry.width;
        var updatedUrl = url ? url : "/assets/images/richTextWithImage.png";
        var imageUrl = "".concat(updatedUrl, "?w=").concat(width * columns, "&h=").concat(rows * heightAccToDevice, "&fit=crop&auto=format");
        return {
            srcset: imageUrl,
            src: imageUrl
        };
    };
    var handleImageClick = function handleImageClick() {
        setShowThumbnailLayout(function(prev) {
            return {
                currIndex: 4,
                isVisible: !prev.isVisible
            };
        });
    };
    var getHeight = function getHeight(index) {
        if (index === 0) {
            return 1.5 * heightAccToDevice;
        }
        return isMobile ? 0.75 * heightAccToDevice : 0.5 * heightAccToDevice;
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)({
        isVisible: false,
        currIndex: 4
    }), showThumbnailLayout = ref3[0], setShowThumbnailLayout = ref3[1];
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref4.widgetContextState.globalStyle;
    var globalBorderRadius = globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.imageCards) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.borderRadius) === null || ref2 === void 0 ? void 0 : ref2.replace("!important", "");
    var cardFrame = props.cardFrame, oneGridCellGeometry = props.oneGridCellGeometry, _gridGapAxis = props.gridGapAxis, gridGapAxis = _gridGapAxis === void 0 ? {} : _gridGapAxis;
    var imagesList = getVisibleImages(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.imagesData);
    var hiddenImageLength = (imagesList === null || imagesList === void 0 ? void 0 : imagesList.length) - 5;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var heightAccToDevice = isMobile ? 150 : 300;
    var columnAccToDeivce = isMobile ? 2 : 4;
    var updatedImageData = (0,react.useMemo)(function() {
        var ref;
        var imageModifiedData = (ref = imagesList === null || imagesList === void 0 ? void 0 : imagesList.slice(0, 5)) === null || ref === void 0 ? void 0 : ref.map(function(data, index) {
            return {
                img: data.imageUrl,
                cols: index === 0 ? columnAccToDeivce : 1,
                rows: 1
            };
        });
        return imageModifiedData;
    }, [
        imagesList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative tw-h-full tw-w-full ".concat(isMobile ? "tw-px-[16px]" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageList_ImageList, {
                sx: {
                    width: "100%",
                    height: "100%"
                },
                variant: "quilted",
                cols: columnAccToDeivce,
                gap: gridGapAxis === null || gridGapAxis === void 0 ? void 0 : gridGapAxis.columnGap,
                children: updatedImageData.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageListItem_ImageListItem, {
                        cols: item.cols || 1,
                        rows: item.rows || 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                height: getHeight(index),
                                width: "100%"
                            },
                            className: "tw-relative tw-h-[100%] tw-w-[100%] tw-overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getSrcSet(item.img, item.rows, item.cols, index)), {
                                    alt: item.title,
                                    loading: "lazy",
                                    decoding: "async",
                                    className: "tw-cursor-pointer ".concat(!isMobile ? (ContentAnimationStyles_module_default())[(0,utils/* getCurrentClass */.WR)(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.hoverEffect)] : ""),
                                    style: {
                                        height: getHeight(index),
                                        width: "100%"
                                    }
                                })),
                                index === 4 && hiddenImageLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        borderRadius: globalBorderRadius
                                    },
                                    onClick: handleImageClick,
                                    className: "tw-absolute tw-bottom-0 tw-right-0 tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-flex-col tw-justify-center tw-bg-[#00000066] ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(isMobile ? "tw-text-[20px]" : "tw-text-[32px]", " tw-flex tw-justify-center tw-gap-[4px] tw-font-normal tw-text-white"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: hiddenImageLength
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, item.img);
                })
            }),
            showThumbnailLayout.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_RenderThumnailModal, {
                cardFrame: cardFrame,
                config: showThumbnailLayout,
                setConfig: setShowThumbnailLayout
            })
        ]
    });
}
/* harmony default export */ var GalleryWidget_GalleryCollage2 = (GalleryCollage2);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/MansoryLayout.tsx








var MasonryGrid = function(props) {
    var handleImageClick = function handleImageClick(index) {
        setShowThumbnailLayout(function(prev) {
            return {
                currIndex: index,
                isVisible: !prev.isVisible
            };
        });
    };
    var listPresentation = props.listPresentation, cardFrame = props.cardFrame, containerTracks = props.containerTracks, oneGridCellGeometry = props.oneGridCellGeometry;
    var ref = (0,react.useState)({
        isVisible: false,
        currIndex: 3
    }), showThumbnailLayout = ref[0], setShowThumbnailLayout = ref[1];
    var imagesList = getVisibleImages(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.imagesData);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-h-full tw-w-full tw-px-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageList_ImageList, {
                variant: "masonry",
                cols: (containerTracks === null || containerTracks === void 0 ? void 0 : containerTracks.numColumns) || 4,
                gap: listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.rowColumnGap,
                children: imagesList.map(function(imageData, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageListItem_ImageListItem, {
                        className: "tw-overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onClick: function() {
                                return handleImageClick(index);
                            },
                            srcSet: imageData.imageUrl ? "".concat(imageData.imageUrl, "?w=").concat(oneGridCellGeometry.width, "&fit=crop&auto=format&dpr=2 2x") : "/assets/images/richTextWithImage.png",
                            src: imageData.imageUrl ? "".concat(imageData.imageUrl, "?w=").concat(oneGridCellGeometry.width, "&fit=crop&auto=format") : "/assets/images/richTextWithImage.png",
                            className: classnames_default()((ContentAnimationStyles_module_default())[(0,utils/* getCurrentClass */.WR)(cardFrame === null || cardFrame === void 0 ? void 0 : cardFrame.hoverEffect)], "tw-cursor-pointer"),
                            loading: "lazy",
                            decoding: "async",
                            height: oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height,
                            style: {
                                maxHeight: 1.25 * (oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height)
                            }
                        })
                    }, imageData.imageUrl + index);
                })
            }),
            showThumbnailLayout.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_RenderThumnailModal, {
                cardFrame: cardFrame,
                config: showThumbnailLayout,
                setConfig: setShowThumbnailLayout
            })
        ]
    });
};
/* harmony default export */ var MansoryLayout = (MasonryGrid);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/GalleryWidget/index.tsx









function GalleryWidget() {
    var renderLayoutType = function renderLayoutType() {
        switch(listPresentation.layoutName){
            case Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
            case Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_CarouselGridLayout, (0,_object_spread/* default */.Z)({}, props, generalValues));
            case Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_ThumbnailLayout, {
                    cardFrame: cardFrame
                });
            case Constants/* COMMON_LAYOUT_TYPE.FOUR */.o_.FOUR:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MansoryLayout, (0,_object_spread/* default */.Z)({}, props, generalValues));
            case Constants/* COMMON_LAYOUT_TYPE.FIVE */.o_.FIVE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_GalleryCollage1, (0,_object_spread/* default */.Z)({}, props, generalValues));
            case Constants/* COMMON_LAYOUT_TYPE.SIX */.o_.SIX:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryWidget_GalleryCollage2, (0,_object_spread/* default */.Z)({}, props, generalValues));
        }
    };
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var props = data.props;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var generalValues = getConfigsAndUtils().generalValues;
    var listPresentation = props.listPresentation, cardFrame = props.cardFrame;
    return renderLayoutType();
}
/* harmony default export */ var components_GalleryWidget = (GalleryWidget);


/***/ }),

/***/ 50722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useLoadVisibleReel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function useLoadVisibleReel(param) {
    var videoRef = param.videoRef, reelIndex = param.reelIndex, setLoadVideo = param.setLoadVideo, loadVideo = param.loadVideo;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (videoRef[reelIndex]) {
            var loadMoreCallback = function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        setLoadVideo(true);
                        observer.unobserve(entry.target);
                    }
                });
            };
            var observer;
            if (!loadVideo) {
                observer = new IntersectionObserver(loadMoreCallback, {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.01
                });
                observer.observe(videoRef[reelIndex]);
            } else {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef[reelIndex]);
            }
            return function() {
                videoRef[reelIndex] && (observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef[reelIndex]));
            };
        }
    }, []);
    return null;
}


/***/ })

}]);